// Shared helpers for numeric <input type="number"> fields so users can't
// type, paste, or scroll their way into a negative value.

// Block the "-" / "+" / "e" keys (minus sign, plus sign, exponent) on keydown.
export const blockNegativeKey = (e) => {
  if (["-", "+", "e", "E"].includes(e.key)) {
    e.preventDefault();
  }
};

// Prevent the mouse wheel from nudging a focused number input into a
// negative value (also avoids the common "accidentally scrolled the page
// and changed the number" bug).
export const blockWheelChange = (e) => {
  e.target.blur();
};

// Clamp a pasted/changed value so it can never go below 0. Pass the raw
// event and a setter — returns the sanitized numeric string.
export const clampNonNegative = (value) => {
  if (value === "" || value === null || value === undefined) return value;
  const n = Number(value);
  if (Number.isNaN(n)) return value;
  return n < 0 ? String(Math.abs(n)) : value;
};

// Convenience prop bundle to spread onto any <Input type="number" />
// that should never accept a negative value.
export const nonNegativeNumberProps = {
  type: "number",
  min: 0,
  onKeyDown: blockNegativeKey,
  onWheel: blockWheelChange,
};
